import { render, staticRenderFns } from "./DispatchFamilyUsers.vue?vue&type=template&id=73a34ba7&scoped=true&"
import script from "./DispatchFamilyUsers.vue?vue&type=script&lang=js&"
export * from "./DispatchFamilyUsers.vue?vue&type=script&lang=js&"
import style0 from "./DispatchFamilyUsers.vue?vue&type=style&index=0&id=73a34ba7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73a34ba7",
  null
  
)

export default component.exports